import { render } from "./ArgonCheckbox.vue?vue&type=template&id=464f0780"
import script from "./ArgonCheckbox.vue?vue&type=script&lang=js"
export * from "./ArgonCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__